<template>
  <div class="details">
    <h2>{{ closure.location }}</h2>
    <input type="button" @click="$emit('go-home')" value="Back" />
    <closure-table :data="closure" :fields="showFields" :singleView="true" @send-location="sendLocation"></closure-table>
    <!-- <input type="button" @click="addFeature('closure')" value="Add to closure"/>
    <input type="button" @click="removeFeature('closure')" value="Remove from closure"/><br />
    <input type="button" @click="addFeature('detour')" value="Add to detour"/>
    <input type="button" @click="removeFeature('detour')" value="Remove from detour"/><br />
    <input type="button" @click="clearFeatures()" value="Clear selected features"/> -->
  </div>
</template>
<script>
// @ is an alias to /src
import ClosureTable from '@/components/ClosureTable.vue'
import axios from 'axios'

export default {
  name: 'closure_details',
  components: {
    ClosureTable
  },
  methods: {
    sendLocation: function (location) {
      this.$emit('send-location', location);
    },
    addFeature: function (type) {
      this.$emit('add-feature-to-route', { id: this.$route.params.id, type: type })
    },
    removeFeature: function (type) {
      this.$emit('remove-feature-from-route', { id: this.$route.params.id, type: type })
    },
    clearFeatures: function (type) {
      this.$emit('clear-features-from-route', { id: this.$route.params.id, type: type })
    },
    updateData: async function () {
      let closure = await axios.get(`${this.siteConfig.opendataService.url}${this.siteConfig.closureDataset.query}&values=${this.$route.params.id}`);
      this.closure = closure.data[0];

      this.$emit('data-loaded', closure.data);
    },
    routeUpdated: function () {
      this.updateData();
    }
  },
  data: function () {
    return {
      closure: { location: "" },
      showFields: [
        { 
            "field": "closing_date",
            "alias": "Closure Date"
        },
        { 
            "field": "opening_date",
            "alias": "Opening Date"
        },
        { 
            "field": "closing_type",
            "alias": "Type"
        },
        { 
            "field": "explanation",
            "alias": "Reason"
        },
        { 
            "field": "detour",
            "alias": "Detour"
        },
        { 
            "field": "is_sidewalk",
            "alias": "Sidewalk Closed"
        },
        { 
            "field": "sidewalk_comments",
            "alias": "Sidewalk Info"
        },
        {
          "field" : "additional_info",
          "alias" : "Additional Info"
        },
        { 
            "field": "contractor",
            "alias": "Contractor"
        },
        {
          "field": "impact_transit",
          "alias": "Transit Impacted"
        } // ,
        // { 
        //     "field": "id",
        //     "alias": "ID"
        // }
      ],
      siteConfig: {}
    }
  },
  created: async function () {
    let siteConfig = await axios.get('../site.json');
    this.siteConfig = siteConfig.data;
    
    this.updateData();
  },
  watch: {
    $route: 'routeUpdated'
  }
}
</script>